import { useEffect, useState } from "react";
import debounce from "lodash/debounce";

const SCROLL_UP = "up";
const SCROLL_DOWN = "down";
const STOP_SCROLL = "stop";

const useDetectScrollState = (thresholdPixels: number, stopDetectLatency: number) => {
  const [scrollState, setScrollState] = useState<typeof SCROLL_UP | typeof SCROLL_DOWN | typeof STOP_SCROLL>();

  useEffect(() => {
    const threshold = thresholdPixels || 0;
    let lastScrollY = window.pageYOffset;
    let ticking = false;

    const updateScrollDir = () => {
      const scrollY = window.pageYOffset;

      if (Math.abs(scrollY - lastScrollY) < threshold) {
        ticking = false;
        return;
      }
      setScrollState(scrollY > lastScrollY ? SCROLL_DOWN : SCROLL_UP);

      lastScrollY = scrollY > 0 ? scrollY : 0;
      ticking = false;
    };

    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(updateScrollDir);
        ticking = true;
      }
    };
    const onScrollStop = debounce(() => {
      setScrollState(STOP_SCROLL);
    }, stopDetectLatency);

    window.addEventListener("scroll", onScroll);
    window.addEventListener("scroll", onScrollStop);

    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("scroll", onScrollStop);
    };
  }, [thresholdPixels, stopDetectLatency]);

  return scrollState;
};

export default useDetectScrollState;
